/**
 * El texto de un aviso de Gustavo viene en formato WhatsApp, no en Markdown.
 *
 * Gustavo escribe sus avisos con `*negrita*` —asterisco simple— porque el mismo texto sale
 * por WhatsApp, que es donde vive la mitad de los agentes. Medido sobre los avisos reales:
 * los que tienen formato usan asterisco simple y ninguno usa el doble.
 *
 * En Markdown un asterisco simple es CURSIVA, así que renderizarlo tal cual mostraba
 * "*26,26 créditos*" en itálica flaca —o con los asteriscos crudos a la vista— cuando lo
 * que se quería era destacarlo. (13/08/2026)
 *
 * También traduce `_cursiva_` y `~tachado~`, que son las otras dos marcas de WhatsApp.
 */
export function waAMarkdown(texto: string): string {
  return String(texto ?? '')
    // Negrita: *así* → **así**. Se exige que el asterisco no esté ya duplicado y que
    // abrace texto sin saltos de línea, para no tomar dos asteriscos sueltos de párrafos
    // distintos como si fueran un par.
    .replace(/(^|[^*\w])\*(?!\s)([^*\n]+?)(?<!\s)\*(?![*\w])/g, '$1**$2**')
    // Tachado: ~así~ → ~~así~~ (GFM).
    .replace(/(^|[^~\w])~(?!\s)([^~\n]+?)(?<!\s)~(?![~\w])/g, '$1~~$2~~');
}
